import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { History } from "lucide-react";
import { auditCsvUrl, listAudit } from "../../api/platformAudit";
import { NeuCard } from "../../components/neu/Neu";
import { AuditFilters } from "./AuditFilters";
import { localDateTime } from "../../lib/datetime";

const fmt = (iso) => localDateTime(iso);

export const AuditLog = () => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({ action: "", date_from: "", date_to: "" });
  const [data, setData] = useState({ items: [], actions: [] });

  useEffect(() => {
    listAudit({ ...filters, limit: 200 }).then(setData);
  }, [filters]);

  return (
    <NeuCard data-testid="audit-panel">
      <div className="flex items-center gap-3">
        <History className="h-5 w-5 text-primary" />
        <div>
          <h2 className="text-lg font-black">{t("audit.title")}</h2>
          <p className="text-xs text-muted-foreground">{t("audit.subtitle")}</p>
        </div>
      </div>
      <AuditFilters
        filters={filters}
        setFilters={setFilters}
        actions={data.actions}
        csvUrl={auditCsvUrl(filters)}
      />
      <div className="mt-4 grid gap-2" data-testid="audit-list">
        {data.items.map((row) => (
          <div key={row.id} className="neu-in flex flex-wrap items-center justify-between gap-2 rounded-2xl p-3">
            <div>
              <p className="text-sm font-bold">{t(`audit.actions.${row.action}`, row.action)}</p>
              <p className="text-xs text-muted-foreground">
                {row.actor_email} · {row.target_type} {row.target_id}
              </p>
            </div>
            <p className="font-mono text-xs text-muted-foreground">{fmt(row.at)}</p>
          </div>
        ))}
        {!data.items.length ? <p className="text-sm text-muted-foreground">{t("audit.empty")}</p> : null}
      </div>
    </NeuCard>
  );
};
